module.exports = "/assets/dist/images/how-it-works-engine.svg?106475190105a544eb2642cd9e52a101";